module.exports = __webpack_public_path__ + "static/portfolio-ads-aa-52a1df3ac79148a13c22c49ecaebc9d0.jpg";